var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-split-button" },
    [
      _c(
        "ActivityButton",
        _vm._g(
          {
            attrs: {
              object: _vm.object,
              label: _vm.label,
              "data-bot": _vm.dataBot
            }
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "CompassMenu",
        { attrs: { placement: "bottom-end", size: "small" } },
        [
          _c(
            "button",
            { staticClass: "activity-split-button__icon-button" },
            [
              _c("CompassIcon", {
                attrs: { icon: "caret-down-fill", size: "small" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "dropdown" },
            _vm._l(_vm.menuItems, function(item, index) {
              return _c("CompassMenuItem", {
                key: index,
                attrs: { label: item.label, "data-bot": item.dataBot },
                on: { click: item.action }
              })
            }),
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }